import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { HiOutlineDocumentText, HiOutlineTrash, HiPlus,HiX} from "react-icons/hi"; // Import icons
import axios from "../../utils/axios";
import Select from "react-select";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import DataTable from "react-data-table-component"; // Import the DataTable
import { Editor } from '@tinymce/tinymce-react';

const RoomSales = ({ setIsAuthenticated }) => {
  const navigate = useNavigate(); 
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { url, hotel_id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const [propData, setPropData] = useState({});
  const [roomSalesList, setRoomSalesList] = useState([]); // Store room data for the table
  const [roomSelect, setRoomSelect] = useState([]);
  const [rateList, setRateList] = useState([]);
  
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editingRoom, setEditingRoom] = useState([]);

  const [newRoom, setNewRoom] = useState({
    ROOM_ID: "",
    RATE_ID: "",
    ROOM_SEQUENCE:"",
    status: "1",  
    ROOM_SALE_DESC:"",
  }); // New room form state

  // Fetch hotel details
  const getDetailProperty = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hotel_id}`);
      if (response.status === 200) {
        setPropData(response.data);
      } else {
        throw new Error("Failed to fetch hotel details");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch hotel details");
    } finally {
      setLoading(false);
    }
  };

  // Fetching room select
  const getRoomSelect = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/select/rooms/${hotel_id}`);
      if (response.status === 200) {
        console.log('Room Select:',response.data)
        setRoomSelect(response.data); // Update state for room select options
      } else {
        throw new Error("Failed to fetch room select options");
      }
    } catch (err) {
      console.error(err);
      // toast.error("Error fetching room list");
    } finally {
      setLoading(false);
    }
  };

  const transformedRoomSelect = roomSelect.map(room => ({
    label: room.ROOM_NAME,  // This is the name of the room that will be displayed
    value: room.ID_ROOM    // This is the value that will be sent when the user selects the room
  }));

  const getRateList = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/rooms/rate/${hotel_id}`);
      if (response.status === 200) {
        setRateList(response.data.data);
        console.log('RateList:',response.data.data)
      } else {
        throw new Error("Failed to fetch rate list.");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch room sales data
  const getRoomSaleList = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/rooms/sale/${hotel_id}`);
      if (response.status === 200) {
        setRoomSalesList(response.data.data); // Save room data for the table
        console.log('Response room sale list : ',response.data.data);
        
      } else {
        throw new Error("Failed to fetch room sales data");
      }
    } catch (err) {
      console.error(err);
      // toast.error("Error fetching room sales data");
    } finally {
      setLoading(false);
    }
  };

  // Handle adding new room sale
  const handleAddRoomSale = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const payload = {
        UID: userData.id,
        HOTEL_ID: hotel_id, // Map hotel ID from URL params
        ROOM_ID: newRoom.ROOM_ID,
        RATE_ID: newRoom.RATE_ID,
        status: newRoom.status,
        ROOM_SALE_DESC: newRoom.ROOM_SALE_DESC,
      };
      
      const response = await axios.post(`/api/insert/room/sale`, payload);
      
      if (response.status === 200) {

        toast.success(response.data.message);
        setAddModalOpen(false); // Close modal
        getRoomSaleList(hotel_id); // Reload room sales list
      }
    } catch (error) {
      console.error("Error adding room:", error);
      toast.error("Failed to add room.");
    } finally {
      setLoading(false);
    }
  };

  // Handle editing room sale
  const handleEditRoomSale = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        UID: userData.id,
        HOTEL_ID: hotel_id, // Map hotel ID from URL params
        ROOM_ID: editingRoom.ROOM_ID,
        ORDER_NO : editingRoom.ORDER_NO,
        RATE_ID: editingRoom.RATE_ID,
        ROOM_SALE_DESC: editingRoom.ROOM_SALE_DESC,
        status: editingRoom.status,
      };
      
      const response = await axios.post(`/api/insert/room/sale`, payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        setEditModalOpen(false); // Close modal
        getRoomSaleList(hotel_id); // Reload room sales list
      }
    } catch (err) {
      console.error("Error updating room:", err);
      toast.error("Failed to update room.");
    } finally {
      setLoading(false);
    }
  };

  // Handle deleting room sale
  const handleDeleteRoom = async (idRoomSale) => {
    if (window.confirm("Are you sure you want to delete this room?")) {
      setLoading(true);
      try {
        const response = await axios.post(`/api/delete/room/sale/${idRoomSale}`);
        if (response.status === 200) {
          toast.success(response.data.message);
          getRoomSaleList(hotel_id); // Reload room sales list
        }
      } catch (error) {
        console.error("Error deleting room:", error);
        toast.error("Failed to delete room.");
      } finally {
        setLoading(false);
      }
    }
  };

  const columns = [
    {
      name: "Rate Plan",
      selector: (row) => (
        <>
          <span className="inline-flex items-center px-3 py-1 text-sm font-medium rounded-full bg-blue-100 text-blue-800 mr-2">
            {row.ORDER_NO}
          </span>
          {row.ROOM_NAME} - {row.NAME_RATE}
        </>
      ),
      sortable: true,
      wrap: true,
      style: {
        width: 'auto', // Adjust width as needed
      },
    },
    
    {
      name: "Rate Desc",
      selector: (row) => (
        <div
          className="max-h-[220px] overflow-auto p-2" // Added padding and max-height for scrolling
          dangerouslySetInnerHTML={{ __html: row.ROOM_SALE_DESC }}
          title={row.ROOM_SALE_DESC} // Tooltip for full content on hover
          style={{
            whiteSpace: 'normal',  // Allow text wrapping
            overflow: 'hidden',    // Hide overflow text
            textOverflow: 'ellipsis',  // Display ellipsis for overflowed text
          }}
        />
      ),
      sortable: true,
      wrap: true,
      style: {
        width: '320px',   // Set column width to 320px
        padding: '10px',  // Padding for better readability
      },
    },
    {
      name: "Rate Code",
      selector: (row) => `${row.RATE_CODE}`,
      sortable: true,
      wrap: true,
      style: {
        width: '150px', // Adjust width to fit rate code
      },
    },
    {
      name: "Status Plan",
      selector: (row) => (row.status === 1 ? "Active" : "Inactive"),
      sortable: true,
      wrap: true,
      style: {
        width: '120px', // Adjust width to fit status text
      },
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex items-center space-x-4">
          <button
            className="text-blue-500 hover:text-blue-700"
            onClick={() => {
              setEditingRoom(row);
              setEditModalOpen(true);
            }}
            title="Edit Room"
          >
            <HiOutlineDocumentText size={20} />
          </button>
          <button
            className="text-red-500 hover:text-red-700"
            onClick={() => handleDeleteRoom(row.ID_ROOM_SALE)}
            title="Delete Room"
          >
            <HiOutlineTrash size={20} />
          </button>
        </div>
      ),
    },
  ];
  

  // Custom styles for the table
  const customStyles = {
    table: {
      style: {
        border: "1px solid #ddd",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #ddd",
        padding: "12px",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#f4f4f4",
        fontWeight: "bold",
        borderBottom: "1px solid #ddd",
      },
    },
    cells: {
      style: {
        wordWrap: "break-word",
        whiteSpace: "normal",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #ddd",
        paddingTop: "10px",
      },
    },
  };

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    const userSession = getUser(); // Call getUser to fetch user data from localStorage
    if (userSession) {
      setUserData(userSession); // Store user data in the state if it exists
      getDetailProperty(userHID);
      getRoomSaleList(userHID);
      getRoomSelect(userHID)
      getRateList(userHID)
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
   
  },[]);

  return (
    <div className="flex h-screen bg-gray-200">
      
      <Sidebar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} propertyID={propData.ID_HOTEL || "Loading..."}/>
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} />
        
        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">

          <div className="mb-4 text-xs font-semibold text-[#101827]">
            <span>Ashley Hotel Group</span> &gt; <span>Room Sale Rate Plan</span> &gt;{" "}<span>{propData.NAME_HOTEL}</span>
          </div>

          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
            <DataTable
              columns={columns}
              data={roomSalesList}
              customStyles={customStyles}
              pagination
              progressPending={isLoading}
            />
          </section>
        </main>
        
        <button className="fixed bottom-10 right-10 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-500 transition" onClick={() => setAddModalOpen(true)} title="Add Rate">
          <HiPlus size={24} />
        </button>
        {/* Add and Edit Modals */}

        {/* Add Room Modal */}
        {isAddModalOpen && (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-8 rounded-md w-2/3 h-4/6 overflow-auto">

              <div className="flex justify-between items-center mb-4">
                <h4 className="text-base font-semibold">Adjust Room Sale Rate Plan</h4>
                <HiX 
                  size={24} 
                  onClick={() => setAddModalOpen(false)} 
                  className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
                />
              </div>

              <form onSubmit={handleAddRoomSale}>
                <div className="mb-4">
                  <label className="block text-xs font-medium mb-1">Room</label>
                  <Select
                    options={transformedRoomSelect}
                    getOptionLabel={(e) => e.label}
                    getOptionValue={(e) => e.value}
                    onChange={(e) => setNewRoom({ ...newRoom, ROOM_ID: e.value })}
                    placeholder="Select Room"
                    isClearable
                    className="text-xs"
                  />
                </div>

                {/* Room Rate Select */}
                <div className="mb-4">
                  <label className="block text-xs font-medium mb-1" htmlFor="ROOM_TYPE_ID">
                    Rate
                  </label>
                  <select
                    id="ROOM_TYPE_ID"
                    value={newRoom.ROOM_TYPE_ID}
                    onChange={(e) => setNewRoom({ ...newRoom, RATE_ID: e.target.value })}
                    className="w-full border py-2 px-2 text-xs border-gray-300 rounded-md"
                  >
                    <option value="">Select Rate</option>
                    {rateList && rateList.map((rate) => (
                      <option key={rate.ID_TYPE} value={rate.ID_TYPE}>
                        {rate.RATE_CODE} - {rate.NAME_RATE}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-4">
                  <label className="block text-xs font-medium text-gray-700 mb-1" htmlFor="ROOM_STATUS">
                    Room Status
                  </label>
                  <select
                    id="ROOM_STATUS"
                    value={newRoom.ROOM_STATUS}
                    onChange={(e) => setNewRoom({ ...newRoom, status: e.target.value })}
                    className="w-full border px-2 py-2 text-xs border-gray-300 rounded-md"
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="block text-xs font-medium text-gray-700 mb-1" htmlFor="ROOM_SEQUENCE">
                    Room Sequence
                  </label>
                  <input
                    type="number"
                    id="ROOM_SEQUENCE"
                    onChange={(e) => setNewRoom({ ...newRoom, room_sequence: e.target.value })}
                    className="w-full border px-2 py-2 text-xs border-gray-300 rounded-md"
                    min="0"  // Set minimum value if needed
                    step="1" // Ensures whole numbers
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-xs font-medium text-gray-700 mb-1" htmlFor="ROOM_SALE_DESC">
                    Room Rate Desc
                  </label>
                  <Editor
                    value={newRoom.ROOM_SALE_DESC || ""}
                    apiKey="jzxha84y3xyify9uwj6ec47iceogua3cg0k4ftz1bfvxgbr5"
                    init={{
                      height: 400, // Adjust height as necessary
                      menubar: false,
                      plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table paste code help wordcount"
                      ],
                      toolbar:
                        "undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help",
                      content_style: "body { font-family:Arial, sans-serif; font-size:14px; }"
                    }}
                    onEditorChange={(content) => setNewRoom({ ...newRoom, ROOM_SALE_DESC: content })}
                  />
                </div>

                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    onClick={() => setAddModalOpen(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-blue-500 text-white rounded-md px-4 py-2"
                  >
                    Register Room Sale
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Edit Room Modal */}
        {isEditModalOpen && editingRoom && (
          <div
            className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center"
            onClick={() => setEditModalOpen(false)} // Close on click outside the modal
          >
            <div className="bg-white p-8 rounded-md w-2/3 h-4/6 overflow-auto" onClick={(e) => e.stopPropagation()} >
            
              <div className="flex justify-between items-center mb-4">
                <h4 className="text-base font-semibold">{editingRoom.ROOM_NAME} - {editingRoom.NAME_RATE}</h4>
                <HiX 
                  size={24} 
                  onClick={() => setEditModalOpen(false)} 
                  className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
                />
              </div>

              <form onSubmit={handleEditRoomSale}>

                {/* Room Select */}
                <div className="mb-4">
                  <label className="block text-xs font-medium mb-1">Sequence No.</label>
                  <input
                    type="number"
                    id="ROOM_SEQUENCE"
                    onChange={(e) => setEditingRoom({ ...editingRoom, ORDER_NO: e.target.value })}
                    className="w-full border px-2 py-2 text-xs border-gray-300 rounded-md"
                    min="0"  // Set minimum value if needed
                    step="1" // Ensures whole numbers
                    value={editingRoom.ORDER_NO || ""}
                  />
                </div>

                {/* Room Select */}
                <div className="mb-4">
                  <label className="block text-xs font-medium mb-1">Room</label>
                  <select
                    id="ROOM_ID"
                    value={editingRoom.ROOM_ID || ""} // Ensure value is set correctly or use an empty string if undefined
                    onChange={(e) => setEditingRoom({ ...editingRoom, ROOM_ID: e.target.value })}
                    className="w-full border py-2 px-2 text-xs border-gray-300 rounded-md"
                  >
                    <option value="">Select Room </option>
                    {roomSelect && roomSelect.map((room) => (
                      <option key={room.ID_ROOM} value={room.ID_ROOM}>
                        {room.ROOM_NAME} 
                      </option>
                    ))}
                  </select>
                </div>

                {/* Room Rate Select */}
                <div className="mb-4">
                  <label className="block text-xs font-medium mb-1">Rate</label>
                  <select
                    id="ROOM_TYPE_ID"
                    value={editingRoom.RATE_ID || ""} // Ensure value is set correctly or use an empty string if undefined
                    onChange={(e) => setEditingRoom({ ...editingRoom, RATE_ID: e.target.value })}
                    className="w-full border py-2 px-2 text-xs border-gray-300 rounded-md"
                  >
                    <option value="">Select Room Rate</option>
                    {rateList && rateList.map((rate) => (
                      <option key={rate.ID_TYPE} value={rate.ID_TYPE}>
                        {rate.NAME_RATE} - {rate.RATE_CODE}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Room Status Select */}
                <div className="mb-4">
                  <label className="block text-xs font-medium text-gray-700 mb-1" htmlFor="ROOM_STATUS">
                     Status
                  </label>
                  <select
                    id="ROOM_STATUS"
                    value={editingRoom.status || "1"} // Default to "1" if status is not set
                    onChange={(e) => setEditingRoom({ ...editingRoom, status: e.target.value })}
                    className="w-full border px-2 py-2 text-xs border-gray-300 rounded-md"
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="ROOM_SALE_DESC">
                    Room Rate Desc
                  </label>
                  <Editor
                    value={editingRoom.ROOM_SALE_DESC || ""}
                    apiKey="jzxha84y3xyify9uwj6ec47iceogua3cg0k4ftz1bfvxgbr5"
                    init={{
                      height: 400, // Adjust height as necessary
                      menubar: false,
                      plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table paste code help wordcount"
                      ],
                      toolbar:
                        "undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help",
                      content_style: "body { font-family:Arial, sans-serif; font-size:14px; }"
                    }}
                    onEditorChange={(content) => setEditingRoom({ ...editingRoom, ROOM_SALE_DESC: content })}
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end space-x-4">
                  <button
                    type="button"
                    onClick={() => setEditModalOpen(false)}
                    className="text-gray-500 text-xs hover:text-gray-700"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-blue-500 text-xs text-white rounded-md px-4 py-2"
                  >
                    Update Room Sales 
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}


      </div>
    </div>
  );
};

export default RoomSales;
